import * as R from "ramda";

export const getCharge = R.pipe(R.propOr([], "charges"), R.nth(0));

export const getTotalPaid = R.pipe(
  R.props(["charges", "refunds"]),
  R.flatten,
  R.pluck("amount"),
  R.sum,
);

export const getPaidTransactions = R.reject(
  R.allPass([R.propEq("unpaid", "status"), R.propEq([], "charges"), R.propEq([], "refunds")]),
);

export const getPaymentMethodSummary = R.prop("payment_method_summary");
